import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../state/reducers';
import {
  hasAggregation,
  hasAggregationSelected,
} from '../../search-utils/searchFiltersUtils';
import { buildAggregationFilters } from '../search-snippets/aside/filter-selected/searchFiltersUtils';

const mapState = ({ aggregations, queryParams }: StateType) => ({
  shouldDisplayCategory: hasAggregation(aggregations, 'pwCategory'),
  hasCategorySelected: hasAggregationSelected(queryParams, 'pwCategory'),
  categoryCount: buildAggregationFilters(
    queryParams.aggregationsPaths,
    'pwCategory',
  ).length,
  shouldDisplayLegislativeFolder: hasAggregation(
    aggregations,
    'pwLegislativeFolder',
  ),
  hasLegislativeFolderSelected: hasAggregationSelected(
    queryParams,
    'pwLegislativeFolder',
  ),
  legislativeFolderCount: buildAggregationFilters(
    queryParams.aggregationsPaths,
    'pwLegislativeFolder',
  ).length,
  type: queryParams.type,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
